var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      attrs: {
        id: "i18nRadio",
        horizontal: "",
        "label-cols": "3",
        "label-size": "md",
        label: _vm.$t("labels.language") + ":"
      }
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { lg: "5" } }, [
            _c(
              "label",
              { staticClass: "customi_label", attrs: { for: "EN" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.locale,
                      expression: "locale"
                    }
                  ],
                  staticClass: "invisible customi_input",
                  attrs: {
                    type: "radio",
                    id: "EN",
                    name: "locale",
                    value: "EN"
                  },
                  domProps: { checked: _vm._q(_vm.locale, "EN") },
                  on: {
                    change: function($event) {
                      _vm.locale = "EN"
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "customi_div radio" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "customi_svg",
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "svg_bg",
                        attrs: { cx: "10", cy: "10", r: "9" }
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "svg_top radio_check",
                        attrs: { cx: "10", cy: "10", r: "6" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("English")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { lg: "5" } }, [
            _c(
              "label",
              { staticClass: "customi_label", attrs: { for: "ES" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.locale,
                      expression: "locale"
                    }
                  ],
                  staticClass: "invisible customi_input",
                  attrs: {
                    type: "radio",
                    id: "ES",
                    name: "locale",
                    value: "ES"
                  },
                  domProps: { checked: _vm._q(_vm.locale, "ES") },
                  on: {
                    change: function($event) {
                      _vm.locale = "ES"
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "customi_div radio" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "customi_svg",
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "svg_bg",
                        attrs: { cx: "10", cy: "10", r: "9" }
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "svg_top radio_check",
                        attrs: { cx: "10", cy: "10", r: "6" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("Castellano")])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Settings/i18n.vue?vue&type=template&id=8c6e1042&
// module id = null
// module chunks = 